type SkeletonProps = { className?: string };

const Skeleton = ({ className = "" }: SkeletonProps) => (
    <div className={`tw-animate-pulse tw-bg-gray-200 ${className}`}></div>
);

export default Skeleton;
